import React from "react"
import { Icon, Popup } from "semantic-ui-react"
import { ACTIVE_VIEWS } from "../../../shared_component/constants/checkout"
import { useTranslation } from "react-i18next"
import ZipEdit from "../Schedule/Shop/ZipEdit"
import ShopSortingComponent from "../../../v1/CarAdvise2/screens/Map/components/ShopSortingComponent"

const FuelStationHeader = ({
  zip,
  activeTab,
  setActiveTab,
  headerLabel,
  isCheckout = true,
  hideListAndMapOptions = false,
  setSortingType,
  sortingType,
  setIsSortOpen,
  isSortOpen,
  ignoreDisabled = false
}) => {
  const { t } = useTranslation("fuelStation")

  return (
    <div className="fuel-station-header">
      <div className="zip-field">
        <span className="fuel-station-label">{headerLabel || t("findFuelStation")}</span>
        {isCheckout ? (
          <ZipEdit />
        ) : (
          <>
            <Icon name="map marker alternate" color="orange" /> <span>{zip ? zip : "-"}</span>
          </>
        )}
      </div>
      <div className="fuel-station-right-section">
        <ShopSortingComponent
          setSortingType={(value) => setSortingType(value)}
          sortingType={sortingType}
          setIsSortOpen={setIsSortOpen}
          isSortOpen={isSortOpen}
          ignoreDisabled={ignoreDisabled}
          showPriceFilter={false}
        />
        {!hideListAndMapOptions && activeTab && (
          <>
            <Popup
              mouseEnterDelay={500}
              mouseLeaveDelay={100}
              on="hover"
              disabled={window.innerWidth < 700}
              trigger={
                <div
                  className="map_header_component"
                  onClick={() => activeTab != ACTIVE_VIEWS.LIST && setActiveTab(ACTIVE_VIEWS.LIST)}
                >
                  <Icon
                    name="unordered list"
                    color={activeTab == ACTIVE_VIEWS.LIST ? "orange" : "grey"}
                  />
                </div>
              }
              content={t("listView")}
              style={{ height: "20px" }}
              basic
            />

            <Popup
              mouseEnterDelay={500}
              mouseLeaveDelay={100}
              disabled={window.innerWidth < 700}
              on="hover"
              trigger={
                <div
                  className="map_header_component map_icon"
                  onClick={() => activeTab != ACTIVE_VIEWS.MAP && setActiveTab(ACTIVE_VIEWS.MAP)}
                >
                  <Icon
                    name="map outline"
                    color={activeTab == ACTIVE_VIEWS.MAP ? "orange" : "#666666"}
                  />
                </div>
              }
              content={t("mapView")}
              style={{ height: "20px" }}
              basic
            />
          </>
        )}
      </div>
    </div>
  )
}

export default FuelStationHeader
